module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Safe-chat-1098ae9ecd9928caec1382ea1d5989af.svg";